module.exports = __webpack_public_path__ + "img/0001.249b6962.gif";